import styled from 'styled-components';

export const AnalyticsPage = styled.div`
  max-width: 1200px;
  margin: 0 auto;
`;

export const PageHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 30px;

  @media (max-width: 768px) {
    align-items: stretch;
    flex-direction: column;
    gap: 12px;
    margin-bottom: 20px;
  }
`;

export const PageTitle = styled.h2`
  font-size: 28px;
  font-weight: 700;
  color: #1e293b;
  margin: 0;

  @media (max-width: 480px) {
    font-size: 22px;
    line-height: 1.3;
  }
`;

export const DateRange = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;

  @media (max-width: 480px) {
    width: 100%;

    select {
      width: 100%;
    }
  }
`;

export const DateSelector = styled.select`
  padding: 8px 12px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  font-size: 14px;
  background: white;
  cursor: pointer;
  min-width: 150px;
`;

export const AnalyticsOverview = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
  margin-bottom: 30px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 12px;
    margin-bottom: 20px;
  }
`;

export const OverviewCard = styled.div`
  background: white;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
  border: 1px solid #e2e8f0;
  display: flex;
  align-items: center;
  gap: 16px;
  transition: transform 0.2s ease, box-shadow 0.2s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
  }

  @media (max-width: 480px) {
    padding: 16px;
  }
`;

export const CardIcon = styled.div`
  font-size: 32px;
  width: 60px;
  height: 60px;
  background: #30D5C8;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
`;

export const CardContent = styled.div`
  flex: 1;
`;

export const CardValue = styled.div`
  font-size: 24px;
  font-weight: 700;
  color: #1e293b;
  margin-bottom: 4px;
`;

export const CardLabel = styled.div`
  font-size: 14px;
  color: #64748b;
  margin-bottom: 8px;
`;

export const CardChange = styled.span`
  font-size: 12px;
  font-weight: 600;
  padding: 4px 8px;
  border-radius: 6px;
`;

export const PositiveChange = styled(CardChange)`
  background: #dcfce7;
  color: #166534;
`;

export const NegativeChange = styled(CardChange)`
  background: #fee2e2;
  color: #991b1b;
`;

export const AnalyticsCharts = styled.div`
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: 30px;
  margin-bottom: 30px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 16px;
    margin-bottom: 20px;
  }
`;

export const ChartSection = styled.div`
  background: white;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
  border: 1px solid #e2e8f0;

  @media (max-width: 480px) {
    padding: 16px;
  }
`;

export const SectionHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;

  @media (max-width: 480px) {
    align-items: flex-start;
    flex-direction: column;
    gap: 10px;
  }
`;

export const SectionTitle = styled.h3`
  font-size: 18px;
  font-weight: 600;
  color: #1e293b;
  margin: 0;
`;

export const ChartControls = styled.div`
  display: flex;
  gap: 8px;
`;

export const ChartButton = styled.button`
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  padding: 6px 12px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;

  &.active {
    background: #3b82f6;
    color: white;
    border-color: #3b82f6;
  }

  &:hover:not(.active) {
    background: #f1f5f9;
  }
`;

export const ChartContainer = styled.div`
  height: 300px;
  display: flex;
  align-items: center;
  justify-content: center;

  @media (max-width: 480px) {
    height: 240px;
    overflow-x: auto;
    justify-content: flex-start;
  }
`;

export const MockChart = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: end;
  justify-content: space-between;
  padding: 20px;
  background: #f8fafc;
  border-radius: 8px;

  @media (max-width: 480px) {
    min-width: 420px;
    padding: 14px;
  }
`;

export const ChartBars = styled.div`
  display: flex;
  align-items: end;
  gap: 12px;
  width: 100%;
  height: 100%;

  @media (max-width: 768px) {
    gap: 8px;
  }
`;

export const ChartBar = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
`;

export const BarFill = styled.div`
  background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%);
  border-radius: 4px 4px 0 0;
  min-height: 20px;
  width: 100%;
  transition: all 0.3s ease;
`;

export const BarLabel = styled.div`
  font-size: 12px;
  color: #64748b;
  font-weight: 500;
`;

export const BarValue = styled.div`
  font-size: 10px;
  color: #94a3b8;

  @media (max-width: 768px) {
    display: none;
  }
`;

export const TopProductsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const ProductItem = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px;
  background: #f8fafc;
  border-radius: 8px;
`;

export const ProductRank = styled.div`
  font-size: 16px;
  font-weight: 700;
  color: #3b82f6;
  width: 24px;
  text-align: center;
`;

export const ProductInfo = styled.div`
  flex: 1;
`;

export const ProductName = styled.div`
  font-weight: 600;
  color: #1e293b;
  margin-bottom: 4px;
`;

export const ProductStats = styled.div`
  display: flex;
  gap: 12px;
  font-size: 12px;
  color: #64748b;
`;

export const ProductProgress = styled.div`
  width: 60px;
  height: 4px;
  background: #e2e8f0;
  border-radius: 2px;
  overflow: hidden;
`;

export const ProgressBar = styled.div`
  height: 100%;
  background: linear-gradient(135deg, #30D5C8 0%, #511e2b 100%);
  border-radius: 2px;
  transition: width 0.3s ease;
`;

export const AnalyticsInsights = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 30px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const InsightsSection = styled.div`
  background: white;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
  border: 1px solid #e2e8f0;
`;

export const SegmentsChart = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const SegmentItem = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

export const SegmentInfo = styled.div`
  flex: 1;
  min-width: 120px;
`;

export const SegmentName = styled.div`
  font-weight: 600;
  color: #1e293b;
  margin-bottom: 4px;
`;

export const SegmentCount = styled.div`
  font-size: 12px;
  color: #64748b;
`;

export const SegmentPercentage = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1;
`;

export const PercentageBar = styled.div`
  flex: 1;
  height: 8px;
  background: #e2e8f0;
  border-radius: 4px;
  overflow: hidden;
`;

export const PercentageFill = styled.div`
  height: 100%;
  background: linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%);
  border-radius: 4px;
  transition: width 0.3s ease;
`;

export const PercentageText = styled.div`
  font-size: 12px;
  font-weight: 600;
  color: #64748b;
  min-width: 30px;
  text-align: right;
`;

export const InsightsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const InsightItem = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 16px;
  background: #f8fafc;
  border-radius: 8px;
`;

export const InsightIcon = styled.div`
  font-size: 20px;
  width: 24px;
  text-align: center;
  margin-top: 2px;
`;

export const InsightContent = styled.div`
  flex: 1;
`;

export const InsightTitle = styled.div`
  font-weight: 600;
  color: #1e293b;
  margin-bottom: 4px;
`;

export const InsightText = styled.div`
  font-size: 14px;
  color: #64748b;
  line-height: 1.5;
`;
